import React, { useMemo } from "react";
import { SimpleForm, required } from "react-admin";

import FileInput from "./inputs/FileInput";
import ResearchProjectDocTypeInput from "./inputs/ResearchProjectDocTypeInput";
import { Toolbar } from "ra-friendsofbabba";
import { useLocation } from "react-router-dom";

const Form = (props) => {
  const { record } = props;
  const location = useLocation();
  const prevUrl = useMemo(
    () =>
      location.state
        ? `${location.state?.from?.pathname}${location.state?.from?.search}`
        : undefined,
    [location]
  );

  return (
    <SimpleForm
      {...props}
      initialValues={{ ...record }}
      toolbar={
        <Toolbar
          backTab={4}
          backReferenceTarget="research_project_id"
          backReference="research-projects"
          backRedirect={prevUrl}
        />
      }
    >
      <ResearchProjectDocTypeInput
        source="research_project_doc_type_id"
        validate={required()}
      />
      <FileInput source="media" validate={required()} />
    </SimpleForm>
  );
};
export default Form;
